export enum DeviceChipType {
  SINGLE_CHIP = 0,
  DUAL_CHIP = 1,
  INVALID = 2,
}

export enum DeviceType {
  WALLET = 0,
  RECOVERY = 1,
  INVALID = 2,
}

export interface DeviceAccount {
  path: string;
  address: string;
  xpub: number[];
}

export interface TokenRecord {
  tokenName: string;
  address: string;
  ticker: string;
  decimals: number;
  chainId: string;
  /** Hex-encoded metadata passed to the device so it can display token info during signing */
  binary: string;
}

export type ConnectionState = "disconnected" | "connecting" | "connected";

export enum UserConfirmationRequest {
  OPEN_APP = 0,
  SIGN_TX = 1,
  SIGN_MSG = 2,
}

export enum UserConfirmationResponse {
  CONFIRMED = 0,
  REJECTED = 1,
  ALREADY_OPENED = 2,
}
